// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

let w: { [key: string]: any } = window;

const errorHint = 'Please check the environment variables in the frontend/src/environment/environment.ts file.';

/* 
  ! READ ME if you came here via the chrome/firefox developer console

  Make sure that for every entry in the environment object below, there also is a proper version of it in public/environment.js file.

  public/environment.js is a file that is generated during container startup from environment.template.js and the env variables.
  It replaces the placeholders with the container's env variables. 
  
  As you open the page (index.html), the environment.js gets loaded and stores its values in the window['env'] object. 

  To have nice typings, we present a facade of the window['env'] object via this frontend/src/environment/environment.ts file by loading the stored values from the window['env'] object.
  
  If you need the values anywhere in your code, you can import this file and use the nicely typed environment object.

  ! If you don't have a public/environment.js file while developing locally, 
  ! copy public/environment.template.js to public/environment.js and fill it with proper values.
*/

export const environment = {
  production: w['env']['debug'] || false,

  apiUrl:
    w['env']['apiUrl'] || console.error('ENV: "apiUrl" not set. ' + errorHint),

  frontendUrl:
    w['env']['frontendUrl'] || console.error('ENV: "frontendUrl" not set. ' + errorHint),

  wooCommerceUrl:
    w['env']['wooCommerceUrl'] || console.error('ENV: "wooCommerceUrl" not set. ' + errorHint),

  supabaseUrl:
    w['env']['supabaseUrl'] || console.error('ENV: "supabaseUrl" not set. ' + errorHint),
    
    supabaseAnonKey:
    w['env']['supabaseAnonKey'] || console.error('ENV: "supabaseAnonKey" not set. ' + errorHint),
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
